import * as d3 from 'd3';

type LinearGraphArguments = {
  startPosition: number;
  endPosition: number;
  domainMax: number;
};
type BarGraphArguments = {
  startPosition: number;
  endPosition: number;
  paddingRatio?: number;
  domain: (string | number)[] | d3.InternSet<string>;
};

export const createLinearScale = ({
  startPosition,
  endPosition,
  domainMax,
}: LinearGraphArguments) => {
  const range = [startPosition, endPosition];
  const domain = [0, domainMax] as d3.NumberValue[];
  const scale = d3.scaleLinear(domain, range);
  return { scale };
};

export const createBandScale = ({
  startPosition,
  endPosition,
  paddingRatio,
  domain,
}: BarGraphArguments) => {
  const range = [startPosition, endPosition];
  const scale = d3.scaleBand(domain, range);
  if (paddingRatio) {
    scale.padding(paddingRatio);
  }
  return { scale };
};
